import "core-js/modules/es.function.name.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/no-img-video.png';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-cf95e880"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  id: "relatedVideo"
};
var _hoisted_2 = ["onClick"];
var _hoisted_3 = {
  class: "mv-play"
};

var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "play-all"
  }, [/*#__PURE__*/_createElementVNode("span", {
    class: "play-sanjiao"
  })], -1
  /* HOISTED */
  );
});

var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0
  }, null, -1
  /* HOISTED */
  );
});

var _hoisted_6 = {
  class: "mv-descc"
};
var _hoisted_7 = {
  class: "mv-name morelittle"
};
var _hoisted_8 = ["onClick"];
var _hoisted_9 = {
  key: 1,
  class: "mv-artist"
};
var _hoisted_10 = {
  class: "video-icon"
};
var _hoisted_11 = {
  class: "playCount"
};

var _hoisted_12 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("i", {
    class: "iconfont icon-play4"
  }, null, -1
  /* HOISTED */
  );
});

var _hoisted_13 = {
  class: "durction"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_image = _resolveComponent("el-image");

  var _directive_thousand = _resolveDirective("thousand");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.relatedList, function (item) {
    return _openBlock(), _createElementBlock("div", {
      class: "music-mvv",
      key: item.id,
      onClick: function onClick($event) {
        return _ctx.videoClick(item.id || item.vid);
      }
    }, [_createCommentVNode(" 左边视频 "), _createElementVNode("div", _hoisted_3, [_hoisted_4, _createCommentVNode(" 图片 "), _createVNode(_component_el_image, {
      src: item.cover || item.coverUrl
    }, {
      placeholder: _withCtx(function () {
        return [_hoisted_5];
      }),
      _: 2
      /* DYNAMIC */

    }, 1032
    /* PROPS, DYNAMIC_SLOTS */
    , ["src"])]), _createCommentVNode(" 右边信息 "), _createElementVNode("div", _hoisted_6, [_createElementVNode("p", _hoisted_7, _toDisplayString(item.name || item.title), 1
    /* TEXT */
    ), item.artists ? (_openBlock(), _createElementBlock("p", {
      key: 0,
      class: "mv-artist",
      onClick: _withModifiers(function ($event) {
        return _ctx.artistClick(item.artists[0].id);
      }, ["stop"])
    }, _toDisplayString(item.artists[0].name), 9
    /* TEXT, PROPS */
    , _hoisted_8)) : (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(item.creator[0].userName), 1
    /* TEXT */
    ))]), _createCommentVNode(" 播放量和时间 "), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_hoisted_12, _withDirectives((_openBlock(), _createElementBlock("span", null, [_createTextVNode(_toDisplayString(item.playCount || item.playTime), 1
    /* TEXT */
    )])), [[_directive_thousand]])]), _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$filters.formatTime(item.duration, "mm:ss")), 1
    /* TEXT */
    )])], 8
    /* PROPS */
    , _hoisted_2);
  }), 128
  /* KEYED_FRAGMENT */
  ))]);
}